import {
    CARD_PATTERN,
    VA_PATTERN,
    CHIP_PIN_PATTERN,
    PREV_PAYMENTS_PATTERN,
    PAYPAL_PATTERN,
    CREDIT_CARD_PATTERN,
    CARD_TERM_OR_PDQ_PATTERN,
    VSP_PATTERN, CASH_PATTERN,
    CASH_NAME,
    VSP_NAME,
    CARD_NAME,
    CREDIT_CARD_NAME,
    PAYPAL_NAME,
    PREV_PAYMENT_NAME,
    CHIP_PIN_NAME,
    VA_NAME
} from './transactionConstants';

const DEFAULT_ERROR_MESSAGE = "Unrecognized string format";

export const parsePaymentString = (transaction) => {
    try {
        if (transaction.startsWith('Card Ending: PayPal') || transaction.startsWith('Paypal Ending')) {
            return parseCardPaypalEnding(transaction);
        } else if (transaction.startsWith('Card Ending')) {
            return parseCardEnding(transaction);
        } else if (transaction.startsWith('VirtualAssistant Ending')) {
            return parseVirtualAssistantEnding(transaction);
        } else if (transaction.startsWith('Chip & Pin Ending')) {
            return parseChipAndPinEnding(transaction);
        } else if (transaction.startsWith('PREVIOUSPAYMENTS Ending')) {
            return parsePreviousPaymentsEnding(transaction);
        } else if (transaction.startsWith('CARD PDQ') || transaction.startsWith('CARD TERM')) {
            return parseCardTermOrPdqPayment(transaction);
        } else if (transaction.startsWith('CREDIT CARD')) {
            return parseCreditCardPayment(transaction);
        } else if (transaction.startsWith('VSP Payment Made On')) {
            return parseVspPayment(transaction);
        } else if (transaction.startsWith('Cash Ending') || transaction.toLowerCase().startsWith('cash payment')) {
            return parseCashEnding(transaction);
        }
        else {
            return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
        }
    }
    //to-do add logger
    catch (er) {
        return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
    }
};

//Card Ending
const parseCardEnding = (transaction) => {
    const parts = transaction.match(CARD_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: CARD_NAME,
            amount: `£${parts[1]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//Virtual Assistant Ending
const parseVirtualAssistantEnding = (transaction) => {
    const parts = transaction.match(VA_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: VA_NAME,
            amount: `£${parts[1]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

// Chip & Pin Ending
const parseChipAndPinEnding = (transaction) => {
    const parts = transaction.match(CHIP_PIN_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: CHIP_PIN_NAME,
            amount: `£${parts[1]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//Previous Payments Ending
const parsePreviousPaymentsEnding = (transaction) => {
    const parts = transaction.match(PREV_PAYMENTS_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: PREV_PAYMENT_NAME,
            amount: `£${parts[1]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//PayPal Ending
const parseCardPaypalEnding = (transaction) => {
    const parts = transaction.match(PAYPAL_PATTERN);

    if (parts) {
        return {
            date: parts[2] || parts[4],
            method: PAYPAL_NAME,
            amount: `£${parts[1] || parts[3]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//Credit Card
const parseCreditCardPayment = (transaction) => {
    const parts = transaction.match(CREDIT_CARD_PATTERN);

    if (!parts) {
        return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
    }

    if (parts[1]) {
        //CREDIT CARD Payment Made On
        return {
            date: parts[1],
            method: CREDIT_CARD_NAME,
            amount: '' // No amount provided in this format
        };
    } else {
        //CREDIT CARD (PDQ) Payment Taken
        return {
            date: parts[3],
            method: CREDIT_CARD_NAME,
            amount: `£${parts[2]}`
        };
    }
};

//Card Term Or Pdq
const parseCardTermOrPdqPayment = (transaction) => {
    const parts = transaction.match(CARD_TERM_OR_PDQ_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: CARD_NAME,
            amount: '' // No amount provided in this format
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//VSP
const parseVspPayment = (transaction) => {
    const parts = transaction.match(VSP_PATTERN);

    if (parts) {
        return {
            date: parts[1],
            method: VSP_NAME,
            amount: '' // No amount provided in this format
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};

//Cash
const parseCashEnding = (transaction) => {
    const parts = transaction.match(CASH_PATTERN);

    if (parts) {
        return {
            date: parts[2],
            method: CASH_NAME,
            amount: `£${parts[1]}`
        };
    }

    return { error: DEFAULT_ERROR_MESSAGE, originalTransaction: transaction };
};


// WEBPACK FOOTER //
// ./src/parts/Basket/TransactionHystory/transactionStringParser.js